<template>
  <div class="d d_xm">
    <headers :goBack="goBack" />
    <template v-if="list">
      <form2 :list="list" />
      <div-footer :status="status" :isShow="true" :formId="2" :id="id" />
    </template>

    <template v-else>
      <van-empty description="暂无相关数据" />
    </template>
  </div>
</template>
<script>
import { reactive, toRefs, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getsubmitData } from "@/service/form";
import { format } from "@/common/js/utils";
import divFooter from "@/components/Footer";
import headers from "@/components/Header";
import Form2 from "@/components/form/Form2";
// import { Dialog } from "vant";

export default {
  // 总辅
  name: "detailForm2",
  components: {
    divFooter,
    headers,
    Form2,
  },
  beforeRouteEnter(to, from, next) {
    console.log(to.path, from.path);
    next((vm) => {
      // vm 是当前组件的实例
      const zUrl = ["/info/wtg", "info/ytj"];
      if (zUrl.indexOf(from.path) !== -1) {
        vm.isShowTips = true;
      }
    });
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const state = reactive({
      isShowTips: false,
      id: null,
      list: {},
      status: null,
    });

    onMounted(async () => {
      const { id } = route.query;
      const result = await getsubmitData({ dataId: id });
      const { code, data } = result;
      if (code == 10000 && data) {
        const newObj = {};
        for (const i of data.list) {
          newObj[i.fieldCode] = i.value;
        }
        state.list = newObj;
        //   赋值
        Object.assign(state, newObj);
        console.log('newObj-->', state)

        state.status = data.status;
        state.id = data.id;
        if (state.isShowTips) {
          // tips(data.status);
        }
      }
    });

    const goBack = () => {
      router.go(-1);
    };

    // const tips = (status) => {
    //   let msg = "";
    //   switch (status) {
    //     case 0:
    //       msg = "您提交的信息已提交审核，审核通过后将自动发布，请等待审核结果~";
    //       break;
    //     case 1:
    //       msg = "您提交的信息已通过审核并计入统计结果";

    //       break;
    //     case 2:
    //       msg = "您提交的信息未通过审核，请修改后重新提交";
    //       break;
    //   }
    //   if (msg !== "") {
    //     Dialog.alert({
    //       message: msg,
    //     }).then(() => {});
    //   }
    // };

    return {
      ...toRefs(state),
      format,
      goBack,
    };
  },
};
</script>
<style lang="less" scoped>
.body {
  margin-bottom: 1.43333rem;
}
ul {
  display: flex;
  justify-content: space-between;
  padding: 0.26667rem 0.42667rem;
  overflow: hidden;
  color: #323233;
  font-size: 0.37333rem;
  line-height: 0.64rem;
  background-color: #fff;
  border-bottom: 0.02667rem solid #ebedf0;
}
ul li {
  text-align: center;
  border-bottom: #dcdcdc;
  flex: 1;
}
ul li.color {
  color: #969799;
}
</style>
